(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click', function (event) {
  var link = event.target.closest('.sava-mobile-menu a');
  if (!link) return;
  var menu = link.closest('details');
  if (menu) menu.open = false;
});
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  var menu = document.querySelector('.sava-mobile-details[open]');
  if (!menu) return;
  menu.open = false;
  menu.querySelector('summary').focus();
});

  } catch(e) { console.error(e); }
})();
})();
